import { LegalDoc } from "@/components/site/LegalDoc";

export default function PrivacyPage() {
  return (
    <LegalDoc
      eyebrow="Privacy Policy"
      title="Your Privacy Matters."
      updated="July 2026"

      intro="Welcome to Time2Cash, a product of DIGISWING Innovation Private Limited ('Company', 'we', 'our', or 'us'). We value your trust and are committed to protecting your privacy. This Privacy Policy explains how we collect, use, process, store, disclose, and safeguard your information whenever you access or use the Time2Cash mobile application, website (www.time2cash.co), or any services provided through our platform. By using Time2Cash, you acknowledge that you have read, understood, and agreed to the practices described in this Privacy Policy."

      sections={[

{
h:"About Time2Cash",

p:[

"Time2Cash is a hyperlocal digital platform developed by DIGISWING Innovation Private Limited with the objective of connecting individuals, businesses, service providers, job seekers, buyers, sellers, local communities, and various everyday services through a single technology platform.",

"Our platform enables users to discover nearby opportunities, connect with verified businesses, explore local listings, find community assistance, communicate with nearby users, and access several location-based features designed to make everyday life simpler and more connected.",

"Time2Cash only acts as a technology platform facilitating interactions between users. We do not own, manage, supervise, employ, guarantee or directly provide the services, products, jobs, businesses, or transactions listed by users unless specifically stated."
]

},

{
h:"Acceptance of this Privacy Policy",

p:[

"By downloading, installing, accessing, registering, browsing, or otherwise using Time2Cash, you voluntarily consent to the collection, storage, processing and use of your information in accordance with this Privacy Policy.",

"If you do not agree with any part of this Privacy Policy, you should discontinue the use of our services immediately."

]

},

{
h:"Information We Collect",

p:[

"In order to provide a secure, reliable and personalized experience, Time2Cash may collect different categories of information depending on the features you use. Some information is provided directly by you, while certain information is collected automatically when you interact with our platform."

],

list:[

"Full Name",

"Mobile Number",

"Profile Photograph ",

"Gender ",

"Location",

"Business Information (where applicable)",

"Profile Preferences",

"Communication Preferences"

]

},

{
h:"Information You Voluntarily Provide",

p:[

"When you use Time2Cash, you may voluntarily provide information while creating your account, updating your profile, contacting support, participating in promotional campaigns, registering your business, applying for opportunities, creating listings, sharing media, submitting reviews, joining community programs, or using any other feature available on our platform.",

"The information you voluntarily choose to share depends entirely upon the feature you use. Since these actions are initiated by you, they are considered to be provided with your knowledge and consent.",

"Certain information submitted by you may be displayed to other users wherever required to enable the intended functionality of the platform. For example, contact details, business information, profile details, descriptions, images or similar information may be shown where necessary to facilitate communication, discovery or interactions between users."

]

},

{
h:"Automatically Collected Information",

p:[

"When you access Time2Cash, certain technical information is collected automatically in order to improve performance, maintain security, prevent misuse, understand usage patterns and enhance overall user experience.",

"This information generally does not directly identify you but helps us improve our services."

],

list:[

"Device Model",

"Operating System",

"Application Version",

"Browser Information",

"Device Identifier",

"IP Address",

"Network Information",

"Language Settings",

"Crash Reports",

"Performance Logs",

"Diagnostic Information",

"Session Information"

]

},

{
h:"Location Information",

p:[

"Time2Cash is fundamentally built as a location-based platform. Several services available within the application rely on your geographical location to provide accurate and relevant results.",

"With your permission, we may collect your precise location, approximate location, selected city or manually entered location depending upon the permissions granted on your device.",

"Location information enables us to display nearby opportunities, businesses, services, local requirements, marketplace listings, community updates, relevant recommendations and other location-based experiences.",

"You remain in complete control of your location permissions and may revoke or modify them anytime through your device settings. Please note that disabling location permissions may affect the availability or accuracy of certain features."

]

},

{
h:"Device Permissions",

p:[

"Time2Cash may request certain permissions on your device solely to enable features that you choose to use. Permissions are requested only when required and can be managed through your device settings at any time."

],

list:[

"Location — To provide nearby services and recommendations.",

"Camera — To capture profile photos, business images, listings or documents.",

"Photos & Media — To upload images from your gallery.",

"Notifications — To deliver important updates, alerts and platform communications.",

"Microphone (where applicable) — For future supported features requiring audio input.",

"Storage (where applicable) — To upload or manage files selected by you."

]

},

{
h:"User Generated Content",

p:[

"Time2Cash allows users to voluntarily publish information including descriptions, images, profile details, business information, public posts, listings, reviews, ratings, comments, messages and other content through various features of the platform.",

"Such content is submitted entirely at your discretion and may become visible to other users wherever necessary for the intended operation of the platform.",

"We encourage users not to publish sensitive personal information that they do not wish to make available to other users."

]

},

{
h:"Consent for Platform Features",

p:[

"Time2Cash offers multiple integrated community features through a single application. Whenever you voluntarily choose to use any feature of our platform, you acknowledge that the information submitted by you is being provided with your consent for the purpose of delivering that particular service.",

"Depending on the feature being used, certain information may be shared with nearby users, businesses, service providers or other relevant participants solely to facilitate communication, service delivery, community interaction or other intended functionality.",

"We only use the information necessary to operate the feature selected by you and do not process unrelated information without an appropriate legal basis or your consent."

]

},
{
  h: "How We Use Your Information",

  p: [
    "The information collected by Time2Cash is used only for legitimate business purposes and to provide a secure, personalized and reliable experience. We process your information only where it is necessary to operate our platform, comply with legal obligations, improve our services or where you have provided your consent.",

    "Our goal is to make Time2Cash simple, useful and relevant for every user while protecting your privacy."
  ],

  list: [
    "Create and manage your account.",
    "Verify your identity and prevent unauthorized access.",
    "Provide personalized recommendations based on your location.",
    "Enable communication between users.",
    "Display nearby opportunities and relevant services.",
    "Improve search accuracy and recommendations.",
    "Respond to customer support requests.",
    "Notify you about important account activity.",
    "Detect fraud, abuse and suspicious activities.",
    "Maintain platform safety and security.",
    "Improve application performance and reliability.",
    "Conduct research and analytics to improve our services.",
    "Comply with applicable legal obligations."
  ]
},

{
  h: "Information Sharing",

  p: [
    "We respect your privacy and do not sell, rent or trade your personal information to third parties for marketing purposes.",

    "Certain information may be shared only where it is necessary to operate the platform, provide services requested by you, comply with applicable laws or protect the rights and safety of our users."
  ],

  list: [
    "With other users where required by the feature you voluntarily use.",
    "With trusted service providers working on our behalf.",
    "With payment providers for processing transactions.",
    "With cloud hosting providers.",
    "With legal authorities where required by applicable law.",
    "To investigate fraud, abuse or security incidents.",
    "To protect the rights, safety and property of Time2Cash and its users."
  ]
},

{
  h: "Third-Party Services",

  p: [
    "Time2Cash may integrate with trusted third-party services to provide specific functionality. These providers process information in accordance with their own privacy policies and security practices.",

    "Examples of services that may be used include:"
  ],

  list: [
    "Google Play Services",
    "Firebase",
    "Google Maps Platform",
    "Google Analytics",
    "Google AdMob",
    "Payment Gateway Providers",
    "Cloud Infrastructure Providers",
    "Messaging and Notification Services"
  ]
},

{
  h: "Cookies & Website Analytics",

  p: [
    "When you visit our website, we may use cookies, similar technologies and analytics tools to improve your browsing experience.",

    "Cookies help us remember preferences, understand website usage, analyse traffic and improve performance. You may disable cookies through your browser settings, although certain website features may not function correctly."
  ]
},

{
  h: "Communication",

  p: [
    "Time2Cash may communicate with you through notifications, SMS, email, WhatsApp, telephone or other available communication channels for purposes including account verification, security alerts, support responses, service announcements, promotional campaigns and important platform updates.",

    "Where required by law, you may opt out of promotional communications while continuing to receive essential service-related notifications."
  ]
},

{
  h: "Data Security",

  p: [
    "Protecting your information is one of our highest priorities. We implement commercially reasonable administrative, technical and physical safeguards designed to protect personal information against unauthorized access, misuse, alteration, disclosure or destruction.",

    "Our security practices may include secure authentication, encrypted communications, controlled system access, monitoring, backups and regular security improvements.",

    "While we continuously strive to protect your information, no internet-based system or method of electronic storage can be guaranteed to be completely secure."
  ]
},

{
  h: "Data Retention",

  p: [
    "We retain your information only for as long as it is reasonably necessary to provide our services, fulfil the purposes described in this Privacy Policy, comply with applicable legal requirements, resolve disputes, enforce our agreements and maintain platform security.",

    "Information that is no longer required may be securely deleted, anonymised or archived in accordance with applicable laws."
  ]
},

{
  h: "Your Rights",

  p: [
    "Subject to applicable law, you may exercise certain rights regarding your personal information."
  ],

  list: [
    "Access your personal information.",
    "Update inaccurate information.",
    "Correct incomplete information.",
    "Request deletion of your account.",
    "Withdraw permissions granted through your device.",
    "Contact us regarding your personal information.",
    "Request clarification regarding our privacy practices."
  ]
},

{
  h: "Account Deletion",

  p: [
    "You may permanently delete your Time2Cash account at any time using the Account Deletion option available through our platform or by contacting our support team.",

    "Upon receiving your request, we will verify your identity before processing the deletion request.",

    "Certain records may continue to be retained where required for legal compliance, fraud prevention, dispute resolution or enforcement of our legal obligations."
  ]
},

{
  h: "Children's Privacy",

  p: [
    "Time2Cash is not intended for children under the age permitted by applicable laws to independently use our services.",

    "We do not knowingly collect personal information from children. If we become aware that such information has been collected unintentionally, we will take appropriate steps to remove it as soon as reasonably practicable."
  ]
},

{
  h: "Changes to this Privacy Policy",

  p: [
    "We may revise or update this Privacy Policy periodically to reflect changes in our services, legal requirements or business practices.",

    "The updated version will always be published on our website along with the revised 'Last Updated' date. Continued use of Time2Cash after such changes constitutes acceptance of the updated Privacy Policy."
  ]
},

{
  h: "Contact Us",

  p: [
    "If you have any questions, concerns, suggestions or requests regarding this Privacy Policy or our privacy practices, please contact us.",

    "Time2Cash",
    "A Product of DIGISWING Innovation Private Limited",
    "Website: https://time2cash.co",
    "Email: hello@time2cash.co",
    "Support: help@time2cash.co"
  ]
},

{
  h: "Grievance Officer",

  p: [
    "In accordance with applicable Indian laws, including the Digital Personal Data Protection Act, 2023 and other applicable regulations, users may contact our designated Grievance Officer for any complaints relating to personal data or privacy concerns.",

    "Grievance Officer",
    "DIGISWING Innovation Private Limited",
    "Email: hello@time2cash.co"
  ]
},

{
  h: "Your Consent",

  p: [
    "By downloading, installing, registering, accessing or using Time2Cash, you acknowledge that you have carefully read and understood this Privacy Policy and voluntarily consent to the collection, storage, processing, use and disclosure of your information as described herein.",

    "Your continued use of the platform signifies your ongoing acceptance of this Privacy Policy and any updates made to it from time to time."
  ]
}

      ]}
    />
  );
}